<template>
	<mobile-card style="font-size: 14px">
		<template slot="title">
			<div class="charge-card-title">{{ pageText.ticket_notify }}</div>
		</template>

		<template slot="content">
			<div class="flex-form-info">
				<div class="left" style="line-height: 38px">{{ pageText.email }}：</div>
				<div
					class="right"
					style="width: 70%; border-bottom: 1px #dcdee0 solid; border-top: 0px; border-left: 0px; border-right: 0px">
					<van-field
						input-align="right"
						label-align="left"
						size="14px"
						:placeholder="pageText.email_placeholder"
						style="padding: 0px; margin: 0px; height: 31px; line-height: 32px; padding-right: 5px"
						v-model="item.email" />
				</div>
			</div>
		</template>
	</mobile-card>
</template>
<script>
import MobileCard from 'components/mobile-card/index'
import util from 'utils/util'

export default {
	name: 'chargeCard',
	components: { MobileCard },
	props: {
		item: Object
	},
	data() {
		return {
			pageText: {
				ticket_notify: this.$t('pay_ticket.ticket_notify'),
				email: this.$t('pay_ticket.email'),
				email_placeholder: this.$t('pay_ticket.email_placeholder')
			}
		}
	},
	watch: {},
	methods: {
		getParam() {
			return this.item
		}
	},
	mounted() {},
	created() {}
}
</script>
<style lang="scss" scoped>
.charge-card-title {
	/*font-size: 16px;*/
	/*font-weight: bold;*/
	color: #005423;
	background: #e9e9e9;
	height: 6vh;
	display: flex;
	flex-direction: column;
	justify-content: center;
	border-radius: 5px 5px 0 0;
}

.charge-card {
	width: 90vw;
	margin: 2vh auto;
	background: #ffffff;
	border-radius: 5px;

	.card-info {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		// padding: 2vw 4vw;
		padding: 10px 16px;

		.left {
			flex: auto;
			text-align: left;
			vertical-align: center;
		}

		.right {
			flex: auto;
			text-align: right;
		}
	}
}

.input-border {
	/deep/ .van-field__body {
		border: 1px solid #005423;
		border-radius: 5px;
		padding-right: 5px;
		padding-left: 5px;
	}
}

.text-field {
	padding-top: 0px;
	padding-right: 0px;
}

.link {
	text-decoration: underline;
	color: #005423;
}

/deep/ .van-checkbox__icon .van-icon {
	border-color: #ababab;
}

/deep/ .van-checkbox__label {
	color: #005423;
}

/deep/ .van-field {
	font-size: 14px;
}

/deep/ .van-field__label {
	text-align: left;
}

/deep/ .flex-form-info {
	height: 38px;
	padding-top: 0px;
}

/deep/ .van-dropdown-item__content {
	width: 90%;
	left: 5%;
}

/deep/ .van-dropdown-menu__title {
	font-size: 14px;
}
</style>
